import log from 'salvo-lite/log'
import 'dom-slider'

class Slide {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = Object.assign({
            elemToChange: 'next',
            action: 'toggle',
            delay: 0,
            slide: '',
            maxWidth: 99999999999,
            minWidth: 0
        }, JSON.parse(this._elem.getAttribute('data-slide') || '{}'))
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('click', () => {
            if (window.innerWidth <= this._data.maxWidth && window.innerWidth >= this._data.minWidth) {
                const element = this._getElement(this._data.elemToChange)
                if (element) {
                    this._slide(element, this._data.action)
                    if (this._data.closeSiblings) this._closeSiblings(element)
                }
            }
        })
    }

    _getElement (element) {
        switch (element) {
        case 'next':
            return this._elem.nextElementSibling
        case 'prev':
            return this._elem.previousElementSibling
        case 'parent':
            return this._elem.parentNode
        case 'child':
            return this._elem.childElementSibling
        default:
            return document.querySelector(element)
        }
    }

    _slide (element, action) {
        const {slideDown, slideUp, slideToggle} = window.domSlider
        const {delay} = this._data
        switch (action) {
        case 'show':
            slideDown({element, delay})
            break
        case 'hide':
            slideUp({element, delay})
            break
        case 'toggle':
            slideToggle({element, delay})
            break
        default:
            slideToggle({element, delay})
        }
    }

    _closeSiblings (elem) {
        const {slideUp} = window.domSlider
        const siblings = document.querySelectorAll(this._data.closeSiblings)
        siblings.forEach(sibling => {
            if (sibling !== elem) {
                if (this._data.closeSiblingsElement) {
                    slideUp({element: sibling.querySelector(this._data.closeSiblingsElement)})
                } else {
                    slideUp({element: sibling})
                }
            }
        })
    }
}

export default Slide



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slide.js